import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function HourglassIcon(props: SvgIconProps) {
  const defaultColor = '#3E8FFA';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <path
        d='M12.5 4.7275V2.5C12.5 2.23478 12.3946 1.98043 12.2071 1.79289C12.0196 1.60536 11.7652 1.5 11.5 1.5H4.5C4.23478 1.5 3.98043 1.60536 3.79289 1.79289C3.60536 1.98043 3.5 2.23478 3.5 2.5V4.75C3.50034 4.90519 3.53663 5.05818 3.60603 5.19698C3.67543 5.33579 3.77605 5.45662 3.9 5.55L7.16687 8L3.9 10.45C3.77605 10.5434 3.67543 10.6642 3.60603 10.803C3.53663 10.9418 3.50034 11.0948 3.5 11.25V13.5C3.5 13.7652 3.60536 14.0196 3.79289 14.2071C3.98043 14.3946 4.23478 14.5 4.5 14.5H11.5C11.7652 14.5 12.0196 14.3946 12.2071 14.2071C12.3946 14.0196 12.5 13.7652 12.5 13.5V11.2725C12.4996 11.118 12.4636 10.9657 12.3947 10.8274C12.3259 10.6891 12.2261 10.5685 12.1031 10.475L8.82938 8L12.1031 5.525C12.2262 5.43162 12.3261 5.31105 12.3949 5.17272C12.4638 5.03439 12.4997 4.88202 12.5 4.7275ZM11.1394 11H4.83313L8 8.625L11.1394 11ZM4.5 13.5V12H11.5V13.5H4.5ZM11.5 4.7275L8 7.375L4.5 4.75V2.5H11.5V4.7275Z'
        fill={props.color ?? defaultColor}
      />
    </SvgIcon>
  );
}
